export const fallbackHeaderFooter = {
    header: {
        globalMenu: {
            headerButtonMeny: 'Meny',
            startPageUrl: '',
            linkList: [],
            tjenesterMenuItemTitle: 'Tjenester',
            linkListBeforeMenuItems: [
                {
                    text: 'Innstillinger',
                    href: 'https://www.helsenorge.no/innstillinger/',
                    cultureName: '',
                    target: '',
                    title: 'Innstillinger',
                    tjenesteRelativeUrl: '/innstillinger',
                    redirectToTjenester: false,
                },
            ],
            menuItems: [
                {
                    menuTitle: 'Kvalitetssikret helseinformasjon',
                    linkGroupsList: [],
                    subMenuItems: [],
                },
            ],
        },
        searchMenu: {
            headerButtonSok: 'Søk',
            searchPageUrl: '',
            headerMenuSearchTitle: '',
            headerMenuSearchLabel: '',
            headerMenuSearchSubmit: '',
        },
        fasteTekster: {
            headerButtonLogin: 'Logg inn',
            headerButtonLoginUrl: '/auth/signin',
            headerButtonLogout: 'Logg ut',
            headerButtonLogoutUrl: '/auth/signout',
            hoppTilInnholdet: 'Hopp til innhold',
            headerButtonVarsler: 'Varsler',
            headerAriaLabel: '',
            openMenu: '',
            closeMenu: '',
            lightboxInactivityTitle: '',
            lightboxInactivityDescription: '',
            lightboxInactivityTimer: '',
            lightboxInactivityDoYouWantToStay: '',
            lightboxInactivityButtonYes: '',
            lightboxInactivityButtonSignOut: '',
            inactivitySignedOutTitle: '',
            inactivitySignedOutButtonGoToRoot: '',
            inactivitySignedOutButtonSignInAgain: '',
            modalErrorTitle: '',
            modalErrorDescription: '',
            modalErrorButtonText: '',
            representasjonModalTitle: '',
            representasjonModalDescription: '',
            representasjonModalKnapp: '',
            representasjonModalFeilmelding: '',
            representasjonModalFeilmeldingDescription: '',
        },
        profileMenu: {
            headerMenuProfileSistInnlogget: 'Du var sist innlogget ',
            errorVarslinger: 'Det har skjedd en feil. Varslingene kan ikke vises.',
        },
        personvelger: {
            personvelgerHeader: '',
            headerMenuProfileRepresentasjonerDegSelv: '',
            headerMenuProfileRepresentasjonerDuHarFullmakt: '',
            headerMenuProfileRepresentasjonerDuHarForeldreansvar: '',
            personvelgerIngress: '',
            errorInnloggetBruker: '',
            errorHentBruker: '',
            errorValgtPerson: '',
            errorFullmakter: '',
            errorRepresentasjoner: '',
            representasjonerBarn16PlusVarsel: {
                introduction: '',
                link: {
                    text: '',
                    href: '',
                    cultureName: '',
                    target: '',
                    title: '',
                    tjenesteRelativeUrl: '',
                    redirectToTjenester: false,
                },
            },
            representasjonerBarnAnnenAdresseVarsel: {
                introduction: '',
                link: {
                    text: '',
                    href: '',
                    cultureName: '',
                    target: '',
                    title: '',
                    tjenesteRelativeUrl: '',
                    redirectToTjenester: false,
                },
            },
            representasjonerManglendeForeldreansvarVarsel: {
                introduction: '',
                link: {
                    text: '',
                    href: '',
                    cultureName: '',
                    target: '',
                    title: '',
                    tjenesteRelativeUrl: '',
                    redirectToTjenester: false,
                },
            },
            ulestVarsel: '',
            ulesteVarsler: '',
        },
        appInvitation: {
            title: '',
            description: '',
            primaryButtonText: '',
            secondaryButtonText: '',
            closeButtonLabel: '',
        },
    },
    footer: {
        footerMenu: {
            managingEditor: '',
            showCookieBannerText: 'Endre samtykke for informasjonskapsler',
            supportHotline: {
                schemaNumber: '',
                displayNumber: '',
                icon: '',
                displayText: '',
                phoneNumberPrefix: '',
                phoneNumberSuffix: '',
            },
            footerColumns: [],
            languageLinkList: [],
        },
        fasteTekster: {
            footerAriaLabel: '',
        },
    },
};
